@if (password) {
  <div class="password-strength">
    <!-- Progress bar -->
    <div class="mt-2">
      <small class="text-muted">Password Strength: <strong [ngClass]="{'text-danger': strength?.strength === 'Weak', 'text-warning': strength?.strength === 'Medium', 'text-info': strength?.strength === 'Strong', 'text-success': strength?.strength === 'Very Strong'}">{{ strength?.strength || 'None' }}</strong></small>
      <div class="progress" style="height: 5px;">
        <div class="progress-bar" [ngClass]="progressBarClass" [style.width.%]="progressPercentage"></div>
      </div>
    </div>
    <!-- Requirements checklist -->
    @if (showRequirements) {
      <div class="mt-2">
        <small class="text-muted">Requirements:</small>
        <ul class="list-unstyled small">
          @for (req of requirements; track req) {
            <li [ngClass]="{'text-success': isRequirementMet(req), 'text-muted': !isRequirementMet(req)}">
              <i class="fa" [ngClass]="{'fa-check': isRequirementMet(req), 'fa-times': !isRequirementMet(req)}"></i>
              {{ req }}
            </li>
          }
        </ul>
      </div>
    }
    <!-- Error messages if invalid -->
    @if (strength && !strength.valid) {
      <div class="alert alert-danger mt-2 small">
        <strong>Password does not meet requirements:</strong>
        <ul class="mb-0 pl-3">
          @for (error of strength.errors; track error) {
            <li>{{ error }}</li>
          }
        </ul>
      </div>
    }
  </div>
}